import React from 'react';
import Hero from '../components/Hero';
import Intro from '../components/Intro';
import Categories from '../components/Categories';
import About from '../components/About';
import Contact from '../components/Contact';

const Home = () => {
  const handleExplore = () => {
    const el = document.getElementById('categories');
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <>
      {/* Hero and Intro are co-visible in the first viewport */}
      <Hero onExplore={handleExplore} />
      <Intro />
      <Categories />
      <About />
      <Contact />
    </>
  );
};

export default Home;